var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLightForge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 401 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M97.875,35.417l-97.875,0l66.75,31.125l31.125,-31.125Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.185,170.191l97.875,0l-66.75,-31.126l-31.125,31.126Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.265,46.452l-90.196,-10.493l12.456,-35.959l-30.71,29.815l-34.923,-15.223l15.604,20.431l-0.062,0.394l-143.619,0l-40.96,41.044l127.581,59.42l-12.311,12.311l-46.767,0l-22,22l77.887,0l0.01,-0.011l0,0.001l40.95,-41.035l-127.58,-59.42l12.31,-12.31l129.553,0l-37.551,35.49l61.552,-31.925l39.68,25.628l-21.3,-31.386l90.396,-8.772Zm-109.143,8.965c-5.523,0 -10,-4.477 -10,-10c0,-5.523 4.477,-10 10,-10c5.523,0 10,4.477 10,10c0,5.522 -4.476,10 -10,10Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.89148,0,0,3.89148,-234.389,-374.758)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,60.4063,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.114,-0.7l0.074,0l0,0.636l0.392,0l0,0.064l-0.466,0l0,-0.7Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,69.8743,158.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.114,
    y: -0.7,
    width: 0.074,
    height: 0.7,
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,75.8983,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.607,-0.35l0.071,0l0,0.267c-0.033,0.029 -0.071,0.051 -0.116,0.066c-0.045,0.015 -0.092,0.023 -0.141,0.023c-0.07,0 -0.133,-0.015 -0.189,-0.046c-0.056,-0.031 -0.1,-0.073 -0.132,-0.128c-0.032,-0.054 -0.048,-0.115 -0.048,-0.182c0,-0.067 0.016,-0.128 0.048,-0.183c0.032,-0.054 0.076,-0.096 0.132,-0.127c0.056,-0.031 0.119,-0.046 0.19,-0.046c0.053,0 0.102,0.009 0.147,0.025c0.045,0.017 0.082,0.043 0.113,0.076l-0.046,0.047c-0.055,-0.055 -0.126,-0.082 -0.211,-0.082c-0.057,0 -0.108,0.012 -0.153,0.037c-0.046,0.025 -0.082,0.06 -0.108,0.104c-0.026,0.045 -0.039,0.094 -0.039,0.149c0,0.055 0.013,0.104 0.039,0.148c0.026,0.044 0.062,0.079 0.107,0.104c0.045,0.025 0.096,0.038 0.153,0.038c0.072,0 0.133,-0.018 0.183,-0.054l0,-0.236Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,87.5743,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.699,-0.7l0,0.7l-0.073,0l0,-0.323l-0.438,0l0,0.323l-0.074,0l0,-0.7l0.074,0l0,0.312l0.438,0l0,-0.312l0.073,0Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,99.7303,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25,-0.636l-0.246,0l0,-0.064l0.566,0l0,0.064l-0.246,0l0,0.636l-0.074,0l0,-0.636Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,109.018,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.224,-0.591l0,0.213l0.338,0l0,0.11l-0.338,0l0,0.268l-0.13,0l0,-0.7l0.511,0l0,0.109l-0.381,0Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,118.966,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.421,0.01c-0.071,0 -0.136,-0.016 -0.193,-0.047c-0.057,-0.031 -0.102,-0.074 -0.135,-0.129c-0.033,-0.054 -0.049,-0.116 -0.049,-0.184c0,-0.068 0.016,-0.13 0.049,-0.185c0.033,-0.055 0.078,-0.098 0.135,-0.129c0.057,-0.031 0.122,-0.046 0.193,-0.046c0.071,0 0.136,0.015 0.193,0.046c0.057,0.031 0.102,0.074 0.135,0.129c0.033,0.055 0.049,0.116 0.049,0.185c0,0.069 -0.016,0.13 -0.049,0.185c-0.033,0.055 -0.078,0.097 -0.135,0.128c-0.057,0.031 -0.122,0.047 -0.193,0.047Zm0,-0.114c0.047,0 0.089,-0.011 0.126,-0.032c0.037,-0.021 0.067,-0.05 0.088,-0.088c0.021,-0.037 0.032,-0.079 0.032,-0.126c0,-0.047 -0.011,-0.089 -0.032,-0.127c-0.021,-0.037 -0.051,-0.067 -0.088,-0.088c-0.037,-0.021 -0.079,-0.031 -0.126,-0.031c-0.047,0 -0.089,0.01 -0.126,0.031c-0.037,0.021 -0.067,0.051 -0.088,0.088c-0.021,0.038 -0.032,0.08 -0.032,0.127c0,0.047 0.011,0.089 0.032,0.126c0.021,0.038 0.051,0.067 0.088,0.088c0.037,0.021 0.079,0.032 0.126,0.032Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,131.47,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.552,0l-0.143,-0.205c-0.006,0.001 -0.015,0.001 -0.027,0.001l-0.158,0l0,0.204l-0.13,0l0,-0.7l0.288,0c0.061,0 0.113,0.01 0.158,0.03c0.045,0.02 0.08,0.049 0.104,0.086c0.024,0.037 0.036,0.082 0.036,0.133c0,0.053 -0.013,0.098 -0.039,0.136c-0.025,0.038 -0.062,0.066 -0.11,0.085l0.161,0.23l-0.14,0Zm-0.003,-0.451c0,-0.045 -0.015,-0.079 -0.044,-0.103c-0.029,-0.024 -0.072,-0.036 -0.129,-0.036l-0.152,0l0,0.279l0.152,0c0.057,0 0.1,-0.012 0.129,-0.036c0.029,-0.025 0.044,-0.059 0.044,-0.104Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,142.642,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.572,-0.358l0.123,0l0,0.279c-0.036,0.029 -0.078,0.051 -0.126,0.066c-0.048,0.015 -0.097,0.023 -0.148,0.023c-0.071,0 -0.136,-0.016 -0.193,-0.047c-0.057,-0.031 -0.102,-0.073 -0.135,-0.128c-0.033,-0.055 -0.049,-0.116 -0.049,-0.185c0,-0.069 0.016,-0.13 0.049,-0.185c0.033,-0.055 0.078,-0.098 0.135,-0.129c0.058,-0.031 0.123,-0.046 0.195,-0.046c0.059,0 0.112,0.01 0.16,0.029c0.048,0.019 0.088,0.048 0.121,0.085l-0.082,0.08c-0.053,-0.053 -0.118,-0.08 -0.193,-0.08c-0.049,0 -0.093,0.01 -0.132,0.031c-0.038,0.021 -0.068,0.05 -0.09,0.087c-0.021,0.037 -0.032,0.08 -0.032,0.128c0,0.047 0.011,0.089 0.032,0.126c0.022,0.037 0.052,0.067 0.09,0.088c0.039,0.021 0.082,0.032 0.131,0.032c0.055,0 0.103,-0.012 0.144,-0.036l0,-0.218Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12,0,0,12,154.306,158.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.619,-0.109l0,0.109l-0.525,0l0,-0.7l0.511,0l0,0.109l-0.381,0l0,0.182l0.338,0l0,0.107l-0.338,0l0,0.193l0.395,0Z",
    style: {
      fill: "#480095",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.787,252.504l1.834,0l0,15.761l9.714,0l0,1.586l-11.548,0l0,-17.347Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.34,
    y: 252.504,
    width: 1.834,
    height: 17.347,
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,254.09l-6.096,0l0,-1.586l14.026,0l0,1.586l-6.096,0l0,15.761l-1.834,0l0,-15.761Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.228,268.265l0,1.586l-12.267,0l0,-17.347l11.895,0l0,1.586l-10.061,0l0,6.171l8.971,0l0,1.561l-8.971,0l0,6.443l10.433,0Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.212,268.265l0,1.586l-12.267,0l0,-17.347l11.895,0l0,1.586l-10.061,0l0,6.171l8.971,0l0,1.561l-8.971,0l0,6.443l10.433,0Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.48,252.504l7.063,0c1.834,0 3.453,0.368 4.857,1.103c1.404,0.735 2.495,1.76 3.271,3.073c0.777,1.313 1.165,2.813 1.165,4.498c0,1.685 -0.388,3.184 -1.165,4.498c-0.776,1.313 -1.867,2.337 -3.271,3.073c-1.404,0.735 -3.023,1.102 -4.857,1.102l-7.063,0l0,-17.347Zm6.964,15.761c1.52,0 2.85,-0.301 3.99,-0.904c1.14,-0.603 2.024,-1.438 2.651,-2.503c0.628,-1.066 0.942,-2.292 0.942,-3.68c0,-1.388 -0.314,-2.615 -0.942,-3.68c-0.627,-1.066 -1.511,-1.9 -2.651,-2.503c-1.14,-0.603 -2.47,-0.905 -3.99,-0.905l-5.13,0l0,14.175l5.13,0Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.906,
    y: 252.504,
    width: 1.834,
    height: 17.347,
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.717,254.09l-6.097,0l0,-1.586l14.027,0l0,1.586l-6.096,0l0,15.761l-1.834,0l0,-15.761Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.527,
    y: 252.504,
    width: 1.834,
    height: 17.347,
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.551,270c-1.718,0 -3.275,-0.384 -4.672,-1.152c-1.396,-0.769 -2.486,-1.822 -3.271,-3.16c-0.784,-1.338 -1.177,-2.842 -1.177,-4.51c0,-1.669 0.393,-3.172 1.177,-4.51c0.785,-1.339 1.875,-2.392 3.271,-3.16c1.397,-0.768 2.954,-1.152 4.672,-1.152c1.718,0 3.267,0.38 4.646,1.14c1.38,0.759 2.466,1.813 3.259,3.159c0.793,1.347 1.19,2.854 1.19,4.523c0,1.668 -0.397,3.176 -1.19,4.522c-0.793,1.347 -1.879,2.4 -3.259,3.16c-1.379,0.76 -2.928,1.14 -4.646,1.14Zm0,-1.636c1.371,0 2.61,-0.309 3.717,-0.929c1.107,-0.619 1.974,-1.479 2.602,-2.577c0.628,-1.099 0.942,-2.325 0.942,-3.68c0,-1.355 -0.314,-2.582 -0.942,-3.68c-0.628,-1.099 -1.495,-1.958 -2.602,-2.578c-1.107,-0.619 -2.346,-0.929 -3.717,-0.929c-1.371,0 -2.615,0.31 -3.73,0.929c-1.115,0.62 -1.991,1.479 -2.627,2.578c-0.636,1.098 -0.954,2.325 -0.954,3.68c0,1.355 0.318,2.581 0.954,3.68c0.636,1.098 1.512,1.958 2.627,2.577c1.115,0.62 2.359,0.929 3.73,0.929Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.213,252.504l0,17.347l-1.512,0l-11.152,-14.076l0,14.076l-1.833,0l0,-17.347l1.511,0l11.177,14.076l0,-14.076l1.809,0Z",
    style: {
      fill: "#9986b1",
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightForge);
export default __webpack_public_path__ + "static/media/logoLightForge.6e5c3d541611d0f87c0becfe89aea511.svg";
export { ForwardRef as ReactComponent };